module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Medium-Alphabetic.72312aa6.woff";